<!-- 图片上传组件 -->
<template lang="html">
	<div>
		<div class="avatar_kuang el-upload-list--picture-card" v-if="status_if">
			<div class="avatar_li" v-for="(item,index) in list" :key="index">
				<el-image :ref="'imageView'+index" class="image" :src="IMG_URL_SHOW(item)" fit="cover" :preview-src-list="list_list"></el-image>
				<span class="el-upload-list__item-actions">
					<span class="el-upload-list__item-preview" @click="handlePictureCardPreview(item,index,'imageView')"><i class="el-icon-zoom-in"></i></span>
					<span class="el-upload-list__item-delete" @click="delete_f(item,index)"><i class="el-icon-delete"></i></span>
				</span>
			</div>
			<el-upload class="avatar_li" :action="image_up+'front/image_up'" multiple :data="{sub_url:sub_url}"  name="file" :show-file-list="false" :before-upload="before_upload" :on-success="imageSuccess">
				<i class="el-icon-plus avatar-uploader-icon"></i>
			</el-upload>
		</div>
		<div class="avatar_kuang el-upload-list--picture-card" v-else>
			<div class="avatar_li" v-for="(item,index) in list" :key="index">
				<el-image :ref="'1imageView'+index" class="image" :src="IMG_URL_SHOW(item)" fit="cover" :preview-src-list="list_list"></el-image>
				<span class="el-upload-list__item-actions">
					<span class="el-upload-list__item-preview" @click="handlePictureCardPreview(item,index,'1imageView')"><i class="el-icon-zoom-in"></i></span>
					<span class="el-upload-list__item-delete" @click="download(item)"><i class="el-icon-download"></i></span>
				</span>
			</div>
		</div>
		<el-dialog :visible.sync="dialogVisible" append-to-body>
			<img width="100%" :src="IMG_URL_SHOW(dialogImageUrl)" alt="">
		</el-dialog>
	</div>
</template>
<script>
import Download from  '@/../static/js/download.min';
export default {
	name: 'upload',
	data() {
		return {
			image_up:process.env.API_ROOT,
			loading:null,
			list:[],
			dialogImageUrl:'',
			dialogVisible:false,
			list_list:[],
		}
	},
	model: {
		prop: 'value',
		event: 'change'
	},
	props: {
		value: {
			type: Array,
			default:()=>[]
		},
		status_if: {
			type: Boolean,
			default: true
		},
		file_name: {
			type: String,
			default:'',
		},
		sub_url: {
			type: String,
			default:'',
		}
	},
	watch: {
		'value': {
		    immediate: true,
		    handler:function(v){
		    	var list_list = [];
		    	for(var i = 0; i<v.length;i++){
		    		list_list.push(this.IMG_URL(v[i]));
		    	}
				this.list = v;
				this.list_list = list_list;
		    }
		},
	},
	mounted() {

	},
	methods: {
		before_upload(){
			this.loading = this.$loading({
				lock: true,
				text: 'Loading',
				spinner: 'el-icon-loading',
				background: 'rgba(0, 0, 0, 0.7)'
			});
		},
		imageSuccess(res,file){
			if (res.status==200) {
				this.$message.success('图片上传成功');
				var list=this.list;
				list.push(res.data.image[0]);
				this.$emit('callback',list);
			}else{
				this.$message.error(res.message);
			}
			this.loading.close();
		},
		handlePictureCardPreview(data,index,name){
			var type_array=['jpg','jpeg','png','gif','bmp','JPG','JPEG','PNG','GIF','BMP'];
			var img_array=data.split('.');
			var img_type=img_array[img_array.length-1];
			if (type_array.indexOf(img_type)==-1) {
	        	window.open(this.IMG_URL(data));
			}else{
			    this.$refs[name+index][0].showViewer = true;
			}
		},
        download(url,index){
			var type_array=['jpg','jpeg','png','gif','bmp','JPG','JPEG','PNG','GIF','BMP'];
			var img_array=url.split('.');
			var img_type=img_array[img_array.length-1];
			if (type_array.indexOf(img_type)==-1) {
	        	window.open(this.IMG_URL(url));
			}else{
	        	Download(this.IMG_URL(url),this.file_name);
			}
        },
        delete_f(data,index){
        	this.removeByIndex(this.list,index);
			this.$emit('callback',this.list);
        },
	}
}
</script>
<style lang="css" scoped>
.avatar_kuang{
	display: flex;
	flex-wrap: wrap;
	align-items: center;
}
.avatar_kuang .avatar_li{
	margin-bottom: 10px;
	margin-right: 10px;
	position: relative;
}
.avatar_kuang .avatar_li /deep/ .el-upload {
	border: 1px dashed #d9d9d9;
	border-radius: 6px;
	cursor: pointer;
	display: block;
	width: 100px;
	height: 100px;
	line-height: 100px!important;
	font-size: 28px;
	color: #8c939d;
	text-align: center;
}
.avatar_kuang .avatar_li /deep/ .el-upload:hover {
	border-color: #409EFF;
}
.avatar_kuang .avatar_li /deep/ .el-upload .avatar{
	width: 100%;
	height: 100%;
	object-fit: contain;
}
.avatar_kuang .avatar_li /deep/ .image{
	border: 1px dashed #d9d9d9;
	width: 100px;
	height: 100px;
	object-fit: contain;
	display: block;
}
.avatar_kuang .avatar_li /deep/ .avatar-uploader-icon {
	width: 100%;
}
.avatar_kuang .tishi{
	font-size: 14px;
	color: #999999;
	padding-left: 20px;
}
.el-upload-list--picture-card .el-upload-list__item-actions{
/* 	width: 40px; */
/* 	height: 40px; */
}
</style>



// WEBPACK FOOTER //
// src/components/uploads.vue